"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { MEETING_STATUS_OPTIONS, MEETING_TYPE_OPTIONS } from "../constants/meeting-constants";

interface MeetingStatusPreviewProps {
  status: string;
  type: string;
}

export const MeetingStatusPreview: React.FC<MeetingStatusPreviewProps> = ({ status, type }) => {
  return (
    <div className="flex items-center gap-2 p-3 bg-muted rounded-lg">
      <div className="flex items-center gap-2">
        <Badge className={MEETING_STATUS_OPTIONS.find((s) => s.value === status)?.color}>
          {MEETING_STATUS_OPTIONS.find((s) => s.value === status)?.label}
        </Badge>
        {type && (
          <Badge variant="outline">
            {MEETING_TYPE_OPTIONS.find((t) => t.value === type)?.label}
          </Badge>
        )}
      </div>
    </div>
  );
};
